<template>
  <HeaderSection />
  <div>
    <img class="full_width" src="/images/front_banner.webp">
  </div>
  <div class="row pt-5 pb-5 m-0">
    <div class="col-md-2">
      <ul class="list-group">
        <li v-for="post in leftposts" :key="post.id">
          <a href="javascript:;" class="list-group-item m-3 mt-0 mb-1" @click.prevent="loadPost(post.id)">
            {{ post.title }}
          </a>
        </li>
      </ul>
    </div>
    <div class="col-md-8">
      <div v-if="currentPost" class="text-justify">
        <h4 v-if="currentPost">{{ currentPost.title }}</h4>
        <img v-if="currentPost && currentPost.image" :src="currentPost.image" class="mb-4 full_width" alt="Post Image">
        <p v-if="currentPost" v-html="currentPost.description"></p>
      </div>
      <div v-else class="text-center">
        <p>The post text written articles, which will change on monthly basis based.</p>
      </div>
    </div>

    <div class="col-md-2">
      <ul class="list-group">
        <li v-for="post in rightposts" :key="post.id">
          <a href="javascript:;" class="list-group-item m-3 mt-0 mb-1" @click.prevent="loadPost(post.id)">
            {{ post.title }}
          </a>
        </li>
      </ul>
    </div>
  </div>
    <FooterSection />
</template>

<script>
import HeaderSection from "../components/HeaderSection.vue";
import FooterSection from "../components/FooterSection.vue";
import axios from "axios";

export default {
  name: "ArticleArchivePage",
  components: {
    HeaderSection,
    FooterSection,
  },
  data() {
    return {
      leftposts: [],
      rightposts: [],
      currentPost: null,
    };
  },
  mounted() {
    axios.get("https://6footspeakeasy.com/api/leftPosts.php").then((response) => {
      this.leftposts = response.data;
    }).catch((error) => {
      console.error("Error fetching posts:", error);
    });

    axios.get("https://6footspeakeasy.com/api/rightPosts.php").then((response) => {
      this.rightposts = response.data;
    }).catch((error) => {
      console.error("Error fetching posts:", error);
    });
  },
  methods: {
    // Fetch and display the clicked post
    loadPost(postId) {
      axios.get(`https://6footspeakeasy.com/api/getPost.php?id=${postId}`).then((response) => {
        this.currentPost = response.data;
      }).catch((error) => {
        console.error("Error fetching post:", error);
      });
    },
  },
};
</script>

<style>
/* Add styles if needed */

.full_width {
	width: 100%;
}
.list-group {
  list-style: none;
  line-height: 30px;
}
.list-group a {
  background: none !important;
  color: #c4b5a7;
  border: 1px solid #c4b5a7;
}
.text-default {
  color: #c4b5a7 !important;
}
</style>
